import localForage from 'localforage'
const nanoid = require('nanoid')

const getEventsStorageKey = (userId) => {
  return `OnboardingWizardEvents-${userId}`
}

export const sentPromises = []
export const batches = []
var store

export const getStore = (userId) => {
  if (!store) {
    store = localForage.createInstance({
      driver: localForage.INDEXEDDB,
      name: getEventsStorageKey(userId)
    })
  }
  return store
}

export const getEvents = async (userId) => {
  var events = []
  const store = getStore(userId)
  const keys = await store.keys()
  await Promise.all(keys.map(async (keyId) => {
    var value = await store.getItem(keyId)
    events.push({ key: keyId, value })
  }))
  return events
}

export const storeEvent = async (userId, event) => {
  const eventId = nanoid()
  const store = getStore(userId)
  await store.setItem(eventId, event)
  return eventId
}

export const updateEvent = async (userId, eventId, event) => {
  const store = getStore(userId)
  await store.setItem(eventId, event)
}

export const deleteEvent = async (userId, eventId) => {
  const store = getStore(userId)
  await store.removeItem(eventId)
}

export const clearStorage = (userId) => {
  const store = getStore(userId)
  store.clear()
}
